import React, {FC} from "react";
import '../service-find-admin.scss'
import CmsTableWithPrint from "mixins/ui/cms-table-with-print/cms-table-with-print";
import { localize } from "/react4xp/mixins/helpers";
import {columns} from "../static";

const AdditionalContent = ({children}): JSX.Element => <p>{children}</p>

const ServiceFindAdminResponse: FC = (props:any) => {
    const {translations, data, ...remainProps} = props;

    return (
        <>
            <CmsTableWithPrint
                additionalContentToResult={AdditionalContent({
                    children: localize('find-admin-on-date', translations)
                        .replace('__DATE__',data.stateDate)
                })}
                columns={columns(translations)}
                apiUrl='/services/isnaportal/open-api/admin/generate/pdf'
                isPost
                isExportToCSV
                translations = {translations}
                data={data.data}
                total={data.total}
                {...remainProps}
            />
        </>
    );
};

export default ServiceFindAdminResponse;
